/* tslint:disable */
/* eslint-disable */
/**
 * A2B Customer API
 * Internal API for customer management
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@a2b-internet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomerContact } from '../model';
/**
 * CustomerContactApi - axios parameter creator
 */
export const CustomerContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete the customer contact. At least one main contact must always remain.
         * @param {string} customerId The customer ID
         * @param {string} contactId The contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact: async (customerId: string, contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'customerId', customerId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteCustomerContact', 'contactId', contactId)
            const localVarPath = `/v1/customer/{customerId}/contact/{contactId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new customer contact.
         * @param {string} customerId The customer ID
         * @param {CustomerContact} customerContact Contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomerContact: async (customerId: string, customerContact: CustomerContact, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('postCustomerContact', 'customerId', customerId)
            // verify required parameter 'customerContact' is not null or undefined
            assertParamExists('postCustomerContact', 'customerContact', customerContact)
            const localVarPath = `/v1/customer/{customerId}/contact`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerContact, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the customer contact. At least one main contact must always remain.
         * @param {string} customerId The customer ID
         * @param {string} contactId The contact ID
         * @param {CustomerContact} customerContact Contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomerContact: async (customerId: string, contactId: string, customerContact: CustomerContact, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('putCustomerContact', 'customerId', customerId)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('putCustomerContact', 'contactId', contactId)
            // verify required parameter 'customerContact' is not null or undefined
            assertParamExists('putCustomerContact', 'customerContact', customerContact)
            const localVarPath = `/v1/customer/{customerId}/contact/{contactId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{contactId}', encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerContact, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerContactApi - functional programming interface
 */
export const CustomerContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerContactApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete the customer contact. At least one main contact must always remain.
         * @param {string} customerId The customer ID
         * @param {string} contactId The contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerContact(customerId: string, contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerContact(customerId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerContactApi.deleteCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new customer contact.
         * @param {string} customerId The customer ID
         * @param {CustomerContact} customerContact Contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCustomerContact(customerId: string, customerContact: CustomerContact, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCustomerContact(customerId, customerContact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerContactApi.postCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the customer contact. At least one main contact must always remain.
         * @param {string} customerId The customer ID
         * @param {string} contactId The contact ID
         * @param {CustomerContact} customerContact Contact information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCustomerContact(customerId: string, contactId: string, customerContact: CustomerContact, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerContact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCustomerContact(customerId, contactId, customerContact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerContactApi.putCustomerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerContactApi - factory interface
 */
export const CustomerContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerContactApiFp(configuration)
    return {
        /**
         * Delete the customer contact. At least one main contact must always remain.
         * @param {CustomerContactApiDeleteCustomerContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerContact(requestParameters: CustomerContactApiDeleteCustomerContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomerContact(requestParameters.customerId, requestParameters.contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new customer contact.
         * @param {CustomerContactApiPostCustomerContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCustomerContact(requestParameters: CustomerContactApiPostCustomerContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerContact> {
            return localVarFp.postCustomerContact(requestParameters.customerId, requestParameters.customerContact, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the customer contact. At least one main contact must always remain.
         * @param {CustomerContactApiPutCustomerContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCustomerContact(requestParameters: CustomerContactApiPutCustomerContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerContact> {
            return localVarFp.putCustomerContact(requestParameters.customerId, requestParameters.contactId, requestParameters.customerContact, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteCustomerContact operation in CustomerContactApi.
 */
export interface CustomerContactApiDeleteCustomerContactRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * The contact ID
     */
    readonly contactId: string
}

/**
 * Request parameters for postCustomerContact operation in CustomerContactApi.
 */
export interface CustomerContactApiPostCustomerContactRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * Contact information
     */
    readonly customerContact: CustomerContact
}

/**
 * Request parameters for putCustomerContact operation in CustomerContactApi.
 */
export interface CustomerContactApiPutCustomerContactRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * The contact ID
     */
    readonly contactId: string

    /**
     * Contact information
     */
    readonly customerContact: CustomerContact
}

/**
 * CustomerContactApi - object-oriented interface
 */
export class CustomerContactApi extends BaseAPI {
    /**
     * Delete the customer contact. At least one main contact must always remain.
     * @param {CustomerContactApiDeleteCustomerContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomerContact(requestParameters: CustomerContactApiDeleteCustomerContactRequest, options?: RawAxiosRequestConfig) {
        return CustomerContactApiFp(this.configuration).deleteCustomerContact(requestParameters.customerId, requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new customer contact.
     * @param {CustomerContactApiPostCustomerContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCustomerContact(requestParameters: CustomerContactApiPostCustomerContactRequest, options?: RawAxiosRequestConfig) {
        return CustomerContactApiFp(this.configuration).postCustomerContact(requestParameters.customerId, requestParameters.customerContact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the customer contact. At least one main contact must always remain.
     * @param {CustomerContactApiPutCustomerContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putCustomerContact(requestParameters: CustomerContactApiPutCustomerContactRequest, options?: RawAxiosRequestConfig) {
        return CustomerContactApiFp(this.configuration).putCustomerContact(requestParameters.customerId, requestParameters.contactId, requestParameters.customerContact, options).then((request) => request(this.axios, this.basePath));
    }
}

